// JustTheDictionary Prompt Injection Templates

export const DICTIONARY_PROMPTS = {
    WOTD: (word: string, definition: string) => 
        `\n\n[SYSTEM HARNESS CONTEXT: The user is asking for the Word of the Day. Give it to them! The Word of the Day is "${word}". Definition: ${definition}]`,
    
    SEARCH_SUCCESS: (word: string, definition: string, example: string) => 
        `\n\n[SYSTEM HARNESS CONTEXT: Dictionary lookup successful for "${word}". Definition: ${definition}. Example: ${example}. Use this to answer the user's question.]`,
    
    SEARCH_FAILED: () => 
        `\n\n[SYSTEM HARNESS CONTEXT: You searched JustTheDictionary for the requested word but it was not found in the 2.7M word database. Let the user know you don't know it.]`,
    
    FLAVOR: (flavorWords: string) => 
        `\n\n[SYSTEM HARNESS CONTEXT: To sound highly human, edgy, and relatable, you may optionally weave these trending internet slang words into your response if they fit naturally: ${flavorWords}. Do not overdo it to the point of being cringey.]`
};
